export function formatPhoneBR(phone: string | null) {
  if (!phone) return "";

  const digits = phone.replace(/\D/g, "");

  const cleaned = digits.startsWith("55") ? digits.slice(2) : digits;

  if (cleaned.length < 10) return phone;

  const ddd = cleaned.slice(0, 2);
  const number = cleaned.slice(2);

  const firstPart = number.length === 9
    ? number.slice(0, 5)
    : number.slice(0, 4);

  const secondPart = number.length === 9
    ? number.slice(5)
    : number.slice(4);

  return `+55 (${ddd}) ${firstPart}-${secondPart}`;
}
